"use client"
import { Badge } from "@/components/ui/badge"
import { gen_color } from "@/utils/colors"

interface NameBadgeProps {
  name: string
  className?: string
}

export function NameBadge({ name, className }: NameBadgeProps) {
  const { textColorClass, backgroundColor, borderColor } = gen_color(name)
  return (
    <Badge
      className={`${textColorClass} ${className}`}
      style={{
        borderColor,
        backgroundColor
      }}
    >
      {name}
    </Badge>
  )
}